import React, { useState, useEffect, useRef } from "react";
import { Search } from "react-feather";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import JobReportSearch from "../../components/transaction/job-report/JobReportSearch";
import LoadingSpinner from "../../components/LoadingSpinner";
import { generateReport, getReportHeader } from "../../api/reportApi";
import { MODULES, FORMS } from "../../const";

import {Grid} from "../../components/transaction/job-report/ReportGrid";

function JobReport() {
  const auth = useSelector(
    (state) => state.user.permissions[MODULES.Transaction]
  );
  const permissions = auth?.[FORMS.JOB.REPORT.form];
  const downloadPermission = permissions?.FORM?.DOWNLOAD;

  const [activeAccordion, setActiveAccordion] = useState(1);
  const [searchResults, setSearchResults] = useState([]);
  const [config, setConfig] = useState([]);
  const [isSearchResultsPending, setSearchResultsPending] = useState(false);
  const [isHeaderLoading, setIsHeaderLoading] = useState(true);
  const [isSearchClicked, setSearchClicked] = useState(false);
  const gridRef = useRef();
  const [reportName, setReportName] = useState("JOB Report");
  const [lastSearchParams, setLastSearchParams] = useState(null);

  // Load report headers on mount
  useEffect(() => {
    const fetchHeaders = async () => {
      try {
        const reportName = "job_report";
        const response = await getReportHeader(reportName);
        if (
          response &&
          response.reportDetails &&
          response.reportDetails.length > 0
        ) {
          const dynamicConfig = response.reportDetails.map((detail) => {
            return {
              field: detail.columnName,
              headerName: detail.columnAlias,
              type: detail.dataType
            };
          });
          setConfig(dynamicConfig);
        } else {
          throw new Error("No report headers available");
        }
      } catch (error) {
        toast.error("Error loading headers: " + error.message, {
          autoClose: 5000,
          containerId: "Main",
        });
      } finally {
        setIsHeaderLoading(false);
      }
    };
    fetchHeaders().then((r) => console.error(r));
  }, []);

  const handleSearch = async (searchParams) => {
    setSearchClicked(true);
    setSearchResultsPending(true);
    setLastSearchParams(searchParams);

    try {
      const response = await generateReport(searchParams);

      if (response && response.reportData) {
        const mappedResults = mapJobReportsToGridData(response.reportData);
        setSearchResults(mappedResults);
      } else {
        throw new Error("No job reports found.");
      }
    } catch (error) {
      toast.error("Error fetching data: " + error.message, {
        autoClose: 5000,
        containerId: "Main",
      });
    } finally {
      setSearchResultsPending(false);
    }
  };

  const mapJobReportsToGridData = (jobReports) => {
    return jobReports.map((report) => {
      const mappedReport = {};
      config.forEach(({ field }) => {
        if (
          typeof report[field] === "string" &&
          report[field].includes("T") &&
          report[field].includes(":")
        ) {
          mappedReport[field] = formatDate(report[field]);
        } else {
          mappedReport[field] = report[field] || "";
        }
      });
      return mappedReport;
    });
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    return dateString.replace("T", " ").slice(0, 16);
  };

  const handleAccordionClick = (index) => {
    setActiveAccordion(index === activeAccordion ? null : index);
  };

  const handleReset = () => {
    setSearchResults([]);
    setSearchClicked(false);
  };

  return (
    <div>
      {/* Accordion for Search */}
      <div
        className="ui styled accordion"
        style={{ width: "100%", marginBottom: "10px" }}
      >
        <div
          className={`title ${activeAccordion === 1 ? "active" : ""}`}
          onClick={() => handleAccordionClick(1)}
        >
          <div>
            Search
            <Search size={14} style={{ marginLeft: "10px" }} />
            <i className="dropdown icon"></i>
          </div>
        </div>
        <div className={`content ${activeAccordion === 1 ? "active" : ""}`}>
          <JobReportSearch
            searchResHandler={handleSearch}
            resetHandler={handleReset}
          />
          <div className="ui clearing divider"></div>
        </div>
      </div>

      {/* Grid Section */}
      {isSearchClicked && (
        <>
          {isSearchResultsPending || isHeaderLoading ? (
            <LoadingSpinner />
          ) : (
              <Grid
                  heading={reportName}
                  config={config}
                  content={searchResults}
                  ref={gridRef}
                  searchable={true}
                  checkboxSelection={false}
                  downloadParam={lastSearchParams}
              />
          )}
        </>
      )}
    </div>
  );
}

export default JobReport;
